import api from "../api";

export default {
    index({ params } = {}) {
        return api.get(`/merchant/settlements`, { params })
    },
    show(id) {
        return api.get(`/merchant/settlements/${id}`)
    }
}
